import React from "react";
import styled from "styled-components";

export default styled.button`
    background: #5562c0;
    color: white;
    height: 53px;
    font-size: 20px;
    font-weight: 600;
    border: 0;
    text-align: center;
    margin-top: 33px;
    padding: 0 24px;
    margin: 0 5px;

    ${(props) => (props.isDisabled ? {
    'background': 'gray !important',
    'cursor': 'not-allowed !important'
} : '')}

    img {
        margin-left: 12px;
        width: 7px;
    }
`;